// extracted by mini-css-extract-plugin
export default {"step":"CheckSecretQuestion_step--wKF"};